import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import eventModule from '@/store/event'
import { User } from '@/types/User'
import { initialCookie } from '@/utils/storage-init'

const name = 'auth'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store,
  preserveState: Boolean(initialCookie[name])
})
class AuthModule extends VuexModule {
  private currentUser: User | null = null
  private token?: string = ''
  private refreshToken?: string = ''

  get user() {
    return this.currentUser
  }

  get btoken() {
    return this.token || ''
  }

  get isLoggedIn() {
    return !['', undefined, null].includes(this.token)
  }

  @Mutation
  private setCurrentUser(payload: Partial<User>) {
    Vue.set(this, 'currentUser', payload)
  }

  @Mutation
  private logoutUser() {
    Vue.set(this, 'currentUser', null)
    Vue.set(this, 'token', null)
    Vue.set(this, 'refreshToken', null)
    axios.defaults.headers['Authorization'] = `Bearer `
  }

  @Mutation
  private setCurrentTokens(payload: any) {
    Vue.set(this, 'token', payload.token)
    Vue.set(this, 'refreshToken', payload.refreshToken)
    axios.defaults.headers['Authorization'] = `Bearer ${payload.token}`
  }

  @Action({ rawError: true })
  async fetchUser() {
    try {
      const { data } = await axios.get('/users')
      this.context.commit('setCurrentUser', data)
    } catch (error) {
      eventModule.newError('Profil konnte nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async login(payload: any) {
    try {
      const { data } = await axios.post('/authenticate', payload)
      this.context.commit('setCurrentUser', data.user)
      this.context.commit('setCurrentTokens', {
        token: data.token,
        refreshToken: data.refreshToken
      })
    } catch (error) {
      eventModule.newError(
        'Ups! Da ist etwas schief gelaufen. Versuche es bitte erneut!'
      )
    }
  }

  @Action({ rawError: true })
  async register(payload: any) {
    try {
      const { data } = await axios.post('/users', payload)
      if (data) {
        await this.context.dispatch('login', payload)
      }
    } catch (error) {
      eventModule.newError(
        'Ups! Da ist etwas schief gelaufen. Versuche es bitte erneut!'
      )
    }
  }

  @Action({ rawError: true })
  async logout() {
    try {
      this.context.commit('logoutUser')
    } catch (error) {
      eventModule.newError(
        'Ups! Da ist etwas schief gelaufen. Versuche es bitte erneut!'
      )
    }
  }

  @Action({ rawError: true })
  setUser(payload: User) {
    this.context.commit('setCurrentUser', payload)
  }

  @Action({ rawError: true })
  setTokens(payload: { token: string; refreshToken: string }) {
    this.context.commit('setCurrentTokens', payload)
  }
}

export default getModule(AuthModule)
